import api from '../utils/api';

// Fetch all staff members
export const getAllStaff = async (headers) => {
  try {
    const response = await api.get('/api/staff', headers);
    console.log("staffs", response);
    return response.data;
  } catch (error) {
    console.error('Error fetching all staff:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific staff member by ID
export const getStaffById = async (id, headers) => {
  try {
    const response = await api.get(`/api/staff/${id}`, headers);
    console.log("Fetched staff data:", response.data); // Debugging statement
    return response.data;
  } catch (error) {
    console.error('Error fetching staff by ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new staff member
export const createStaff = async (staffData, headers) => {
  try {
    const response = await api.post('/api/staff', staffData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating staff:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing staff member
export const updateStaff = async (id, staffData, headers) => {
  try {
    const response = await api.put(`/api/staff/${id}`, staffData, headers);
    return response.data;
  } catch (error) {
    console.error('Error updating staff:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a staff member
export const deleteStaff = async (id, headers) => {
  try {
    const response = await api.delete(`/api/staff/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error('Error deleting staff:', error.response ? error.response.data : error.message);
    throw error;
  }
};
